import { useNavigate } from "react-router-dom";
import successTick from "../../images/background/checkmark-EUqSK4A5c8.png";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Loader from "../loader/Loader";
import { COLORS } from "../../constants/colors";

export default function ApplicationSuccess() {
  const navigate = useNavigate();

  const isVerified = useSelector((state) => state?.mentor?.profile?.isVerified);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (typeof isVerified === "boolean") {
      setIsLoading(false);
      if (isVerified === true) {
        navigate("/dashboard/home");
      }
    }
  }, [isVerified, navigate]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="flex items-center justify-center bg-gray-100 px-4">
        <div
          className="bg-white rounded-lg shadow-lg p-8 text-center flex flex-col justify-between"
          style={{ height: "calc(100vh - 120px)" }}
        >
          <div className="relative flex justify-center">
            <img src={successTick} alt="Success Tick" className="w-40" />
          </div>

          <h2 className="text-2xl font-bold text-gray-800 mt-4">
            Your Application Submitted Successfully
          </h2>
          <p className="text-gray-600 mt-2 text-sm">
            Your application has been received and will be reviewed in the next
            few hours. If needed, a meeting will be scheduled with you to
            validate your ID, discuss your mentoring experience, and discuss
            your mentoring fees.
          </p>

          <button
            className="text-white font-semibold py-3 px-6 rounded-lg hover:shadow-lg mt-2 max-w-60 mx-auto"
            style={{ backgroundColor: COLORS.purple }}
            onClick={() => {
              navigate("/dashboard/mentorVerificationStatus");
            }}
          >
            See Application Status
          </button>
          <div>Contact us for any questions about our Application</div>
        </div>
      </div>
    </>
  );
}
